import React from 'react';
import { useStyles } from './footer.styles';

export const Footer = ({ children }) => {
	const { classes } = useStyles();

	return <div className={classes.footer}>{children}</div>;
};
